import React, { useState, useEffect } from "react";
import { FormGroup, FormSelect, Row, Col, Button , FormInput} from "shards-react";
import baseUrl from "config/baseUrl";
import ReactPaginate from "react-paginate";
import dayjs from "dayjs";
import "dayjs/locale/es";
import useToken from "shared/hook/useToken";
import {
  SelectTypeUser,
  SelectagencyType,
  SelectAgency,
} from "shared/components";
import agencyType from "shared/utils/agencyType";
import styled from "styled-components";

const axios = require("axios").default;
const StyledStatus = styled.div`
  background-color: ${(props) => (props.bg ? props.bg : "#A3A3A3")};
  padding: 5px;
  border-radius: 6px;
  text-align: center;
  color: #fff;
`;
const AdminUserList = (props) => {
  const { token } = useToken();
  const [agencyTypeData, setAgencyTypeData] = useState(agencyType);
  const [fullName, setFullName] = useState("");
  const [dataAdminUser, setDataAdminUser] = useState(null);
  const [agencyTypeId, setAgencyTypeId] = useState("");
  const [agencyId, setAgencyId] = useState("");
  const [userTypeId, setUserTypeId] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [dateTypeUser, setDateTypeUser] = useState(null);

  useEffect(() => {
    if (token) {
      var data = JSON.stringify({
        params: {
          agencyTypeId: agencyTypeId,
          agencyId: agencyId,
          userType: userTypeId,
          firstNameLastName: fullName
        },
        show: 30,
        page: pageNumber,
        orderBy: "userId",
        orderType: "ASC",
      });

      var config = {
        method: "post",
        url: `${baseUrl}/v1/user/users`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response) => {
          setDataAdminUser(response.data);
          setTotalPage(response.data.totalPage);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [pageNumber, agencyTypeId, agencyId, userTypeId]);
  useEffect(() => {
    const axios = require("axios").default;
    var data = JSON.stringify({
      show: 5,
      page: 1,
      orderBy: "id",
      orderType: "ASC",
    });

    var config = {
      method: "post",
      url: `${baseUrl}/v1/user/usersPermissionSetList`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function(response) {
        setDateTypeUser(response.data);
      })
      .catch(function(error) {
        console.log(error);
      });
  }, []);

  const searchFullName = () => {
    if (token) {
      var data = JSON.stringify({
        params: {
          agencyTypeId: agencyTypeId,
          agencyId: agencyId,
          userType: userTypeId,
          firstNameLastName: fullName
        },
        show: 30,
        page: pageNumber,
        orderBy: "userId",
        orderType: "ASC",
      });

      var config = {
        method: "post",
        url: `${baseUrl}/v1/user/users`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response) => {
          setDataAdminUser(response.data);
          setTotalPage(response.data.totalPage);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
  const nextPage = (page, total_page) => {
    setPageNumber(page + 1);
    setTotalPage(total_page);
  };
  const getAgencyTypeName = (agencyTypeId) => {
    const list = agencyTypeData.filter(
      (item) => item.agencyTypeId === agencyTypeId
    );
    if (list.length > 0) {
      return list[0].agencyTypeName;
    } else {
      return "-";
    }
  };
  const getUserType = (userType) => {
    const list =
      dateTypeUser !== null &&
      dateTypeUser.data.length > 0 &&
      dateTypeUser.data.filter((item) => item.id === userType);
    if (list.length > 0) {
      return list[0].permissionNameSet;
    } else {
      return "-";
    }
  };

  const getStatus = (status) => {
    switch (status) {
      case 2:
        return <StyledStatus bg="#7FBC46">Active</StyledStatus>;
      default:
        return <StyledStatus bg="#A3A3A3">Inactive</StyledStatus>;
    }
  };
  return (
    <>
      <Row>
        <Col md="12">
          <h6 className="bold" style={{ marginBottom: "30px" }}>
            การจัดการผู้ใช้งาน
          </h6>
        </Col>
      </Row>
      <Row>
        <Col md="4">
          <FormGroup>
          <label>ชื่อ-นามสกุล</label>
            <FormInput
              placeholder="ค้นหา"
              name="agencyTypeId"
              onChange={(e) => {
                setFullName(e.target.value);
              }}
              onKeyDown={(e) => {
                if(e.key === "Enter"){
                  searchFullName();
                }
              }}
              value={fullName}
            />
          </FormGroup>
        </Col>
        <Col md="4">
          <FormGroup>
            <label>ประเภทหน่วยงาน/บริษัท</label>
            <SelectagencyType
              placeholder="เลือก"
              name="agencyTypeId"
              onChange={(e) => {
                setAgencyTypeId(e.target.value === "0" ? "" : e.target.value);
                // formik.handleChange(e);
              }}
              defaultValue={agencyTypeId}
              value={agencyTypeId}
            />
          </FormGroup>
        </Col>
        <Col md="4">
          <FormGroup>
            <label>หน่วยงาน/บริษัท</label>
            <SelectAgency
              placeholder="เลือก"
              name="agencyId"
              onChange={(e) => {
                setAgencyId(e.target.value === "0" ? "" : e.target.value);
              }}
              defaultValue={agencyId}
              value={agencyId}
            />
          </FormGroup>
        </Col>
        <Col md="4">
          <FormGroup>
            <label>ประเภทผู้ใช้งาน</label>
            <SelectTypeUser
              placeholder="เลือก"
              name="userTypeId"
              onChange={(e) => {
                setUserTypeId(e.target.value === "0" ? "" : e.target.value);
              }}
              defaultValue={userTypeId}
              value={userTypeId}
            />
          </FormGroup>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col md="8">
          <h6 className="bold" style={{ marginBottom: "30px" }}>
            ตารางแสดงรายการผู้ใช้งานในระบบ
          </h6>
        </Col>
        <Col md="4">
          <a
            className="btn btn-success pull-right"
            href={`/administrator/users/create`}
            role="button"
          >
            + เพิ่มผู้ใช้งาน
          </a>
        </Col>
      </Row>

      <Row>
        <Col md="12">
          <div className="table-responsive">
            <table className="table mb-0">
              <thead className="thead-dark">
                <tr>
                  <th className="mw200" scope="col">
                    ชื่อ-นามสกุล
                  </th>
                  <th className="mw200" scope="col">
                    ประเภทหน่วยงาน/บริษัท
                  </th>
                  <th className="mw160" scope="col">
                    หน่วยงาน/บริษัท
                  </th>
                  <th className="mw100" scope="col">
                    ประเภทผู้ใช้งาน
                  </th>
                  <th className="mw100" scope="col">
                    สถานะ
                  </th>
                  <th className="mw100" scope="col">
                    เครื่องมือ
                  </th>
                </tr>
              </thead>
              <tbody className="table-middle">
                {dataAdminUser != null && dataAdminUser.users.length > 0 ? (
                  dataAdminUser.users.map((item, key) => (
                    <tr key={key}>
                      <td>
                        {item.firstName} {item.lastName}
                      </td>
                      <td>{getAgencyTypeName(item.agencyTypeId)}</td>
                      <td>{item.agencyName}</td>
                      <td>{getUserType(item.userType)}</td>
                      <td>{getStatus(item.userStatus)}</td>
                      <td>
                        <a
                          className="btn-link"
                          href={`/administrator/users/detail/${item.userId}`}
                          role="button"
                        >
                          แก้ไข
                        </a>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5}>ยังไม่มีรายการผู้ใช้งาน</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Col>
        <Col md="12" style={{ textAlign: "right" }}>
          {dataAdminUser != null && (
            <ReactPaginate
              pageCount={totalPage}
              forcePage={pageNumber - 1}
              containerClassName="pagination"
              nextLabel=">"
              previousLabel="<"
              onPageChange={({ selected }) => {
                nextPage(selected, totalPage);
              }}
            />
          )}
        </Col>
      </Row>
    </>
  );
};

export default AdminUserList;
